import { createFileRoute } from "@tanstack/react-router"
import NoosGreigeTab from "~/components/noos-supply-plan/NoosGreigeTab"
import { usePageTracking } from "~/hooks/usePageTracking"

export const Route = createFileRoute(
  "/_auth/procurement/supply-plan/noos/$supplyPlanId/_layout/greige",
)({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("NOOS Supply Plan Detail - Greige")
  return <NoosGreigeTab />
}
